import { __exports as s } from "../../../../_virtual/parse-date.js";
import "../expiration-year.js";
import "./is-array.js";
import { __exports as a } from "../../../../_virtual/is-array.js";
import { __exports as o } from "../../../../_virtual/expiration-year.js";
Object.defineProperty(s, "__esModule", { value: !0 });
s.parseDate = void 0;
var u = o, f = a;
function p(r) {
  var e = Number(r[0]), t;
  return e === 0 ? 2 : e > 1 || e === 1 && Number(r[1]) > 2 ? 1 : e === 1 ? (t = r.substr(1), (0, u.expirationYear)(t).isPotentiallyValid ? 1 : 2) : r.length === 5 ? 1 : r.length > 5 ? 2 : 1;
}
function n(r) {
  var e;
  if (/^\d{4}-\d{1,2}$/.test(r) ? e = r.split("-").reverse() : /\//.test(r) ? e = r.split(/\s*\/\s*/g) : /\s/.test(r) && (e = r.split(/ +/g)), (0, f.isArray)(e))
    return {
      month: e[0] || "",
      year: e.slice(1).join()
    };
  var t = p(r), i = r.substr(0, t);
  return {
    month: i,
    year: r.substr(i.length)
  };
}
s.parseDate = n;
export {
  s as default
};
